import { render, staticRenderFns } from "./RevaluationHistory.vue?vue&type=template&id=0a2cd548&scoped=true"
import script from "./RevaluationHistory.vue?vue&type=script&lang=ts"
export * from "./RevaluationHistory.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationHistory.vue?vue&type=style&index=0&id=0a2cd548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cd548",
  null
  
)

export default component.exports